import { NgClass, NgIf, SlicePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { KursInfoApiService, KursInfoTeilnehmerVO, KursInfoVO } from '@core/api/v1';
import { KursFarben } from '@core/model/kurs-farben';
import { kursTitelMap } from '@core/model/kursTitel';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import TypEnum = KursInfoVO.TypEnum;
import PlatzKontingentEnum = KursInfoTeilnehmerVO.PlatzKontingentEnum;

@Component({
    selector: 'app-kursliste-item',
    standalone: true,
    imports: [RouterLink, NgClass, SlicePipe, FaIconComponent, NgIf],
    templateUrl: './kursliste-item.component.html',
    styleUrl: './kursliste-item.component.scss',
})
export class KurslisteItemComponent implements OnInit {
    @Input() kursItem!: KursInfoVO;

    constructor(private kursService: KursInfoApiService) {}

    veranstaltungsort: string;
    verfuegbarkeit: string;
    istAnmeldefristEingehalten: boolean;
    style: string;
    kursBeschreibung: string;
    kursFarbe: string;

    ngOnInit(): void {
        if (!this.kursItem.freiePlaetze) {
            this.verfuegbarkeit = 'ausgebucht';
            this.style = 'label-danger';
        } else {
            this.verfuegbarkeit = 'Verfügbare Plätze: ' + this.kursItem.freiePlaetze;
            this.style = 'label-success';
        }

        const diff: number = Math.ceil(Math.abs(new Date(this.kursItem.datum!).getTime() - Date.now()) / 1000 / 60 / 60 / 24);
        console.log(this.kursItem.datum);
        console.log(new Date(this.kursItem.datum!).getTime());
        this.istAnmeldefristEingehalten = diff > 14;

        if (!this.istAnmeldefristEingehalten) {
            this.verfuegbarkeit = 'Anmeldefrist abgelaufen';
            this.style = 'label-danger';
        }

        this.kursItem.datum = new Date(this.kursItem.datum!).toLocaleDateString('de-AT', {
            // Anzeigeoptionen
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });

        if (this.kursItem.online) {
            this.veranstaltungsort = 'per Videokonferenz';
        } else {
            this.veranstaltungsort = this.kursItem.veranstaltungsort!;
        }

        if (this.kursItem.beschreibung) {
            this.kursBeschreibung = this.kursItem.beschreibung.replace(/<[^>]+>/g, ' ');
            this.kursBeschreibung = this.kursBeschreibung.replace(/\s+/g, ' ').trim();
        }
        this.kursFarbe = KursFarben.holeClass(this.kursItem.typ as TypEnum);
    }

    titel(typ: TypEnum) {
        return kursTitelMap[typ];
    }
}
